<template src="./html/Edit.html"></template>

<script>
	import Places from './../../projects/places/layout/Places.vue'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	//import Buttons from './Buttons.vue'
	import Navbar from './Navbar'
	import BudgetOrRequest from './BudgetOrRequest'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'places': Places,
			//'buttons': Buttons,
			'navbar': Navbar,
			'budget-or-request': BudgetOrRequest,
		},
		data () {
			return {
				statuses: null,
				partners: null,
				resource: null,
				media: null,
				data: null,
				referrals: null,
				comment: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getStatus()
				this.getData()
				this.getPartners()
				this.getReferrals()
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			getStatus() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getPartners() {
				this.$http.get('admin/partners')
				.then(response => {
					this.partners = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getReferrals() {
				this.$http.get('admin/referrals')
				.then(response => {
					this.referrals = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id + '/edit')
				.then(response => {
					this.data = response.body
					this.comment = null
					this.resource = 'admin/customers/' + this.data.id
					this.budgetOrRequest()
				}).catch(function(response) {
					console.log(response)
				})
			},
			budgetOrRequest() {
				if(this.$route) {
					if(this.$route.query) {
						if(this.$route.query.budget_request) {
							this.$refs.BudgetOrRequest.open()
						}
					}
				}
			},
			reloadData() {
				this.getData()
			},
			update() {
				var loadingTop = Ladda.create(this.$refs.btnStoreTop)
				var loadingBottom = Ladda.create(this.$refs.btnStoreBottom)
				loadingTop.start()
				loadingBottom.start()
				if(this.comment) {
					this.data.comment = this.comment
				}
				this.$http.put('admin/customers/' + this.data.id, this.data)
				.then(response => {
					loadingTop.stop()
					loadingBottom.stop()
					this.reloadData()
					swal({ 
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loadingTop.stop()
					loadingBottom.stop()
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Edit.vue